/**
 * ANQ.ContentServiceManagement.API 
 * Content Service Mgt API
 *
 * OpenAPI spec version: v1
 * Contact: support@coure-tech.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface ContentRate { 
    _id?: string;
    rateId?: string;
    contentProviderName?: string;
    name?: string;
    currency?: number;
    createdOn?: Date;
    effectiveDate?: Date;
    terminationDate?: Date;
    isDedicated?: boolean;
    isDeleted?: boolean;
    isExpired?: boolean;
}